// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ll-0";